import { Helmet } from "react-helmet";

const PageHelmet = ({
  title = "Dashboard",
  description = "Track and manage your campaigns with TraQR.",
  url = process.env.REACT_APP_REDIRECT_URI,
}) => (
  <Helmet>
    <title>{`TraQR - ${title}`}</title>

    <meta property="og:title" content={`TraQR - ${title}`} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={url} />
  </Helmet>
);

export default PageHelmet;
